export const lifecycleGate = {
label: {
draft: "Entwurf",
open: "Offen",
accepted: "Angenommen",
awaiting_assignee_response: "Annahme ausstehend",
assignee_declined: "Vom Zuständigen abgelehnt",
scheduled: "Geplant",
in_progress: "In Bearbeitung",
paused: "Pausiert",
completion_submitted: "Wartet auf Abzeichnung",
completion_rejected: "Nachbearbeitung angefordert",
completion_verified: "Abgezeichnet",
awaiting_follow_on_approval: "Genehmigung ausstehend",
cancelled: "Abgebrochen",
skipped: "Ausgelassen",
},
shortLabel: {
draft: "Entwurf",
open: "Offen",
accepted: "Angenommen",
awaiting_assignee_response: "Ausstehend",
assignee_declined: "Abgelehnt",
scheduled: "Geplant",
in_progress: "Läuft",
paused: "Pausiert",
completion_submitted: "Eingereicht",
completion_rejected: "Nachbearbeitung",
completion_verified: "Abgezeichnet",
awaiting_follow_on_approval: "Genehmigung",
cancelled: "Abgebrochen",
skipped: "Ausgelassen",
},
nextActor: {
draft: "{{name}} schließt den Entwurf ab",
open: "{{name}} nimmt den Auftrag an",
awaiting_assignee_response: "{{name}} nimmt an oder lehnt ab",
assignee_declined: "{{name}} weist den Auftrag neu zu",
scheduled: "{{name}} beginnt die Arbeit",
in_progress: "{{name}} reicht den Abschluss ein",
paused: "{{name}} setzt fort, sobald möglich",
completion_submitted: "{{name}} prüft den Abschluss",
completion_rejected: "{{name}} führt die Nachbearbeitung durch",
completion_verified: "Auftrag ist abgeschlossen",
awaiting_follow_on_approval: "{{name}} entscheidet",
cancelled: "Keine weitere Aktion",
skipped: "Keine weitere Aktion",
},
nextActorYou: {
draft: "Sie schließen den Entwurf ab",
open: "Sie nehmen den Auftrag an",
awaiting_assignee_response: "Sie nehmen an oder lehnen ab",
assignee_declined: "Sie weisen den Auftrag neu zu",
scheduled: "Sie beginnen die Arbeit",
in_progress: "Sie reichen den Abschluss ein",
paused: "Sie setzen fort, sobald möglich",
completion_rejected: "Sie führen die Nachbearbeitung durch",
completion_submitted: "Sie prüfen den Abschluss",
evidence_requested: "Sie ergänzen die angeforderten Nachweise und reichen erneut ein",
awaiting_follow_on_approval: "Sie genehmigen oder lehnen die Folgearbeit ab",
},
};
